import { Fade } from '@chakra-ui/react';
import {
  Box,
  BoxProps,
  Button,
  Heading,
  Icon,
  TextInput,
} from '@hover/blueprint';
import { iSearch, iX } from '@hover/icons';
import React, { FC, useState } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { ArrowButton } from '@hover/shared-components';

interface Props extends BoxProps {
  handleSubmit: Function;
  showBlogLink: boolean;
}

const SearchBarMobile: FC<Props> = ({
  handleSubmit,
  showBlogLink,
  ...rest
}) => {
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const handleClick = () => {
    setIsSearchEnabled(!isSearchEnabled);
  };

  return (
    <Box {...rest}>
      <Box
        display="flex"
        justifyContent="space-between"
        dir="row"
        alignItems="center"
        w="100%"
        py={500}
      >
        <Box w="100%" display={isSearchEnabled ? 'block' : 'none'}>
          <Fade in={isSearchEnabled}>
            <Box
              display="flex"
              justifyContent="space-between"
              dir="row"
              alignItems="center"
              w="100%"
            >
              <TextInput
                name="search"
                placeholder="SEARCH..."
                size="small"
                border="none"
                onChange={e => {
                  handleSubmit({ keyword: e.target.value });
                }}
                _placeholder={{
                  color: 'brandNavy.300',
                  fontSize: '12px',
                  fontWeight: 700,
                  lineHeight: '16px',
                  letterSpacing: '0.15em',
                }}
              />
              <Button
                color="primary"
                fill="minimal"
                shape="circle"
                size="large"
                type="button"
                label="close"
                onClick={() => {
                  handleClick();
                }}
              >
                <Icon color="primary.600" icon={iX} size="medium" />
              </Button>
            </Box>
          </Fade>
        </Box>
        <Box w="100%" display={!isSearchEnabled ? 'block' : 'none'}>
          <Fade in={!isSearchEnabled}>
            <Box
              display="flex"
              justifyContent="space-between"
              dir="row"
              alignItems="center"
              w="100%"
            >
              <Box alignItems="center">
                <Heading size={500} marginBottom={0} isLight as="h1">
                  Blog
                </Heading>
                {showBlogLink && !isSearchEnabled && (
                  <ArrowButton
                    ml={600}
                    as={GatsbyLink}
                    to="/blog/"
                    variant="minimal"
                    sx={{
                      // TODO(buttons): remove when we remove padding in Blueprint
                      div: { pl: 0, pr: 50 },
                    }}
                  >
                    All articles
                  </ArrowButton>
                )}
              </Box>
              <Button
                color="primary"
                fill="minimal"
                shape="circle"
                size="large"
                label="search"
                onClick={() => {
                  handleClick();
                }}
              >
                <Icon color="brandNavy.500" icon={iSearch} size="medium" />
              </Button>
            </Box>
          </Fade>
        </Box>
      </Box>
    </Box>
  );
};

export default SearchBarMobile;
